import { isValid, max, min, parseISO } from "date-fns";

/**
 * Function getting a date range array used to set value of Datepicker. In case only one day is chosen, second argument is null.
 * @param {array} - a collection of objects with dates in string ISO format.
 * @returns {array} - two Dates objects marking start and end of range.
 */
export default (dates: { date: string }[]) => {
  if (!Array.isArray(dates) || dates.length === 0) {
    throw new Error("Input must be a non-empty array.");
  }

  const dateObjects = dates.map((item) => {
    if (!item.date || typeof item.date !== "string") {
      throw new Error("Each item must have a valid date string.");
    }

    const date = parseISO(item.date);
    if (!isValid(date)) {
      throw new Error(`Invalid date format: ${item.date}`);
    }

    return date;
  });

  // Handle single-date case
  if (dateObjects.length === 1) {
    return [dateObjects[0], null];
  }

  return [min(dateObjects), max(dateObjects)];
};
